<template>
    <div class="overview">
        <h1 class="title">Community Contributions</h1>
        <div class="divider purple"></div>
        <div class="category purple">
            <div class="content">
                <div class="description">
                    <h2>Blogs</h2>
                    <p>These are the blogs written by Entelectuals throughout the year</p>
                </div>
                <ul class="names">
                    <li v-for="(blogger, index) in bloggers" :key="index">{{blogger}}</li>
                </ul>
                <div class="stats">
                    <stats-icon :icon-src="statsImages.talkingperson" stat="28"
                                title="Blogs by Entelectuals"></stats-icon>
                </div>
            </div>
        </div>
        <div class="divider blue"></div>
        <div class="category blue">
            <div class="content">
                <div class="description">
                    <h2>Github Contributers</h2>
                    <p>
                        These are the Entelectuals that contributed to various Github repositories throughout the year
                    </p>
                </div>
                <ul class="names">
                    <li v-for="(githubber, index) in githubbers" :key="index">{{githubber}}</li>
                </ul>
                <div class="stats">
                    <stats-icon :icon-src="statsImages.githublogo" stat="3022" title="Github commits"></stats-icon>
                    <stats-icon :icon-src="statsImages.githubcat" stat="245" title="Open source repositories"></stats-icon>
                </div>
            </div>
        </div>
        <div class="divider green"></div>
        <div class="category green">
            <div class="content">
                <div class="description">
                    <h2>Speakers</h2>
                    <p>These are the Entelectuals that presented or talked at various events, conferences or meetups
                        throughout the year</p>
                </div>
                <ul class="names">
                    <li v-for="(speaker, index) in speakers" :key="index">{{speaker}}</li>
                </ul>
                <div class="stats">
                    <stats-icon :icon-src="statsImages.psy" stat="42" title="Entelect Speakers"></stats-icon>
                    <stats-icon :icon-src="statsImages.mic" stat="182" title="Conference and meetup talks"></stats-icon>
                </div>
            </div>
        </div>
        <div class="divider yellow"></div>
        <div class="category yellow">
            <div class="content">
                <div class="description">
                    <h2>Publications</h2>
                    <p>These are the Entelectuals that authored publications throughout the year</p>
                </div>
                <ul class="names">
                    <li v-for="(author, index) in authors" :key="index">{{author}}</li>
                </ul>
                <div class="stats">
                    <stats-icon :icon-src="statsImages.psy" stat="32" title="Authors"></stats-icon>
                    <stats-icon :icon-src="statsImages.document" stat="46" title="Articles"></stats-icon>
                </div>
                <div class="quotes">
                    <div class="quote">
                        <h3 class="post-title">How to Handle Business - Soft Skills</h3>
                        <p class="post">With most of us being very “techy”, we often find ourselves in situations where we find it a bit difficult to communicate our work with business. They don’t understand us – they don’t realise the amount of effort that went into something – they’re constantly changing their minds – we get frustrated – we don’t know how to handle the situation in the best way. There is no definitive answer to the above and as much as these “soft skills” come with experience, there are a few things that we can keep in mind to make this process better and help ease into developing these soft skills required to handle business well. There are many do’s such as listening and knowing your audience, to things not to do like, bombarding people with too much information and speaking over others. The focus should be on building and maintaining solid relationships with people; which forms an important part of the work that we do.  </p>
                        <p class="post-author">- Akira Sooful</p>
                    </div>
                    <div class="quote">
                        <h3 class="post-title">Dev Testing and Its Usefulness</h3>
                        <p class="post">Dev testing or more commonly referred to as developer testing is a process of scrutinizing work that has been completed. It is a technique used in our team in order validate that a ticket is complete before it goes to the client for testing. A great benefit of dev testing is teaching new developers about how the software works, giving them exposure to other areas in the solution. When my fellow graduate and I were assigned to a team, our first challenge was precisely this. And we both agree that it worked well in teaching us about the software. It got us asking questions and I believe promoted faster learning. Moreover, it gives you a safety net to implement a feature without fear of destroying the application.
                        </p>
                        <p class="post-author">- Craig Miles</p>
                    </div>
                    <div class="quote">
                        <h3 class="post-title">A Rookie's Thoughts on Azure</h3>
                        <p class="post">Cloud computing is simply the delivery of computing resources (think data storage, analysis, machine learning, etc.) over the internet on a pay-for-use basis. Cloud computing is very flexible, so whenever you need a bigger cluster, for example, you can simply scale up your cluster when needed, and scale it down later. So instead of having to invest in data centres and servers before even knowing what you or your company needs, you only pay for what you use.  New IT resources are only a click away, and in mere minutes, developers will be able to use the resources they need instead of waiting for weeks for resources to be set up. This dramatically increases the efficiency in organisations, since a lot less time and money are spent on developing and experimenting.
                        </p>
                        <p class="post-author">- Melissa Pistorius</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import StatsIcon from '../../widgets/StatsIcon';
    // Stats images imports
    import talkingperson from '../../assets/images/Community/talking-person.png';
    import githublogo from '../../assets/images/Community/github-logo.png';
    import githubcat from '../../assets/images/Community/github-cat-face.png';
    import psy from '../../assets/images/Community/psy.png';
    import mic from '../../assets/images/Community/microphone.png';
    import document from '../../assets/images/Publications/text-lines.png';
    import like from '../../assets/images/Publications/like.png';

    export default {
        components: {
            'stats-icon': StatsIcon
        },
        data: function () {
            return {
                statsImages: {
                    talkingperson: talkingperson,
                    githublogo: githublogo,
                    githubcat: githubcat,
                    psy: psy,
                    mic: mic,
                    document: document,
                    like: like,
                },
                bloggers: [
                    'Ahmad Mahomed',
                    'Christo Brits',
                    'Dewald De Jager',
                    'Duane McKibbin',
                    'Fashanu Moyo',
                    'Fidaur Haq',
                    'Gail Shaw',
                    'Jacques Van Vuuren',
                    'Jamie Hirst',
                    'Kevin Downs',
                    'Kurt Lourens',
                    'Luke Warren',
                    'Mare Geldenhuys',
                    'Matt Van Der Westhuizen',
                    'Pierre Roux',
                    'Quinton Weenink',
                    'Retief Fourie',
                    'Rishal Hurbans',
                    'Ryan Kotzen',
                    'Sas Van Der Westhuizen',
                    'Sean Buch',
                    'Simon Visser',
                    'Stefan Cronje',
                    'Szymon Welgus',
                    'Thabang Petje',
                    'Tim Lewis',
                    'Tinus Van Den Heever',
                    'Velice Naumoski'
                ],
                githubbers: [
                    'Alex Damasio',
                    'Anthony Farquharson',
                    'Ata-ur-Rasool Haq',
                    'Benjamin Karimazondo',
                    'Bennie van der Walt',
                    'Charl Meyers',
                    'Chris Langsford',
                    'Christopher Araujo',
                    'Craig Vanheerden',
                    'Dean Debree',
                    'Dewald Dejager',
                    'Duane McKibbin',
                    'Enrique Geldenhuys',
                    'Fashanu Moyo',
                    'Fidaur Haq',
                    'Franco Rootman',
                    'Gail Shaw',
                    'Grant Visser',
                    'Gregory Arendse',
                    'Hermanus Brummer',
                    'Jake Helme',
                    'Jesse Leresche',
                    'Johan Aspeling',
                    'JP Strydom',
                    'Kale-ab Tessera',
                    'Kevin Downs',
                    'Kevin Heritage',
                    'Kuresha Nandkishore',
                    'Kurt Lourens',
                    'Lefa Mashele',
                    'Luke Warren',
                    'Lusani Tshigabe',
                    'Marius Kruger',
                    'Matt Vanderwest',
                    'Morne Maritz',
                    'Mzwandile Mahlangu',
                    'Nico Botha',
                    'Patrick Stephansen',
                    'Pierre Roux',
                    'Quinton Weenink',
                    'Regan Koopmans',
                    'Retief Fourie',
                    'Richard O Brien',
                    'Rishal Hurbans',
                    'Rohan Chhipa',
                    'Ryan Kotzen',
                    'Sahil Naran',
                    'Sas Vanderwest',
                    'Sascha Watermeyer',
                    'Steven Carter',
                    'Stian Leroux',
                    'Szymon Welgus',
                    'Talha Asmal',
                    'Tim Lewis',
                    'Timothy Botha',
                    'Tom Hibbers',
                    'Trevor Chikambure',
                    'Ulrich Matthiae',
                    'Velice Naumoski',
                    'Vincent Degois',
                    'Werner Scholtz',
                    'Wilco Boshoff'
                ],
                speakers: [
                    'Akira Sooful',
                    'Alexander Pittendrigh',
                    'Anthony Farquharson',
                    'Arohan Naidoo',
                    'Bami Oni',
                    'Christoff Smith',
                    'Courtney Warmbeck',
                    'Cyril Kgatla',
                    'Daan (Daniel) Keun',
                    'David Weatherhead',
                    'Desere Kruger',
                    'Donné Stevenson',
                    'Edwin Fullard',
                    'Gail Shaw',
                    'Hennie Brink',
                    'Jake Helme',
                    'Johan Van Rooyen',
                    'Justin Weldon',
                    'Kevin Heritage',
                    'Lawrence Puttergill',
                    'Luke Warren',
                    'Madene Marais',
                    'Melissa Pistorius',
                    'Memona Haq',
                    'Nico Botha',
                    'Nicolle Garber',
                    'Nnaemeka Obodoekwe',
                    'Petrus van der Walt',
                    'Pierre Roux',
                    'Privolin Naidoo',
                    'Renette Ros',
                    'Retief Fourie',
                    'Riaan Cornelius',
                    'Rishal Hurbans',
                    'Rohan Chhipa',
                    'Rowan Deysel',
                    'Ryan Kotzen',
                    'Samantha Winfield',
                    'Steven Carter',
                    'Talha Asmal',
                    'Timothy Lewis',
                    'Wayne Winter'
                ],
                authors: [
                    'Akira Sooful',
                    'Amrit Purshotam',
                    'Arohan Naidoo',
                    'Charl Meyers',
                    'Chris Langsford',
                    'Chris Snyders',
                    'Courtney Warmback',
                    'Craig Miles',
                    'Duane McKibbin',
                    'Enrique Geldenhuys',
                    'Gail Shaw',
                    'Gregory Arendse',
                    'Hans Roos',
                    'Jean – Jacques Byleveld',
                    'John Lucey',
                    'Justin Weldon',
                    'Luke Madzedze',
                    'Marius Kruger',
                    'Melissa Pistorius',
                    'Nico Botha',
                    'Nnaemeka Obodoekwe',
                    'Pierre Roux',
                    'Riaan Cornelius',
                    'Rishal Hurbans',
                    'Ronald Mthombeni',
                    'Ryan Kotzen',
                    'Samantha Winfield',
                    'Sas van der Westhuizen',
                    'Saul Lazarus',
                    'Thabang Petje',
                    'Tim Lewis',
                    'Timothy Snayers'
                ]
            }
        },
        methods: {
            track () {
                this.$ga.page('/2018/contributions') // This is for Google Analytics tracking
            }
        }
    }
</script>

<style lang="scss" scoped>
    .overview {
        display: grid;
        grid-auto-rows: auto;

        .purple {
            background: $entelect-purple;
        }

        .blue {
            background: $entelect-dark-blue;
        }

        .green {
            background: $entelect-dark-green;
        }

        .yellow {
            background: $entelect-turquoise;
        }

        .title {
            color: white;
            margin: 24px 0;
            align-self: center;
            justify-self: center;
        }

        .divider {
            width: 100%;
            height: 50px;
            position: relative;

            &.purple:before {
                border-top-color: $dark-gray;
            }

            &.blue:before {
                border-top-color: $entelect-purple;
            }

            &.green:before {
                border-top-color: $entelect-dark-blue;
            }

            &.yellow:before {
                border-top-color: $entelect-dark-green;
            }
        }

        .divider:before {
            content: ' ';
            position: absolute;
            left: 300px;
            width: 0;
            height: 0;
            border-top: 50px solid;
            border-left: 50px solid transparent;
            border-right: 50px solid transparent;

            @media only screen and (max-width: $screen-xs-max) {
                left: 60%;
            }
        }

        .category {
            width: 100%;
            padding-bottom: 24px;
            color: white;
            display: grid;
            grid-gap: 32px;
            grid-template-columns: 1fr 1fr 1fr 1fr;

            @media only screen and (max-width: $screen-md-max) {
                grid-template-columns: 1fr 2fr 2fr 1fr;
            }

            @media only screen and (max-width: $screen-sm-max) {
                grid-template-columns: 1fr 3fr 3fr 1fr;
            }

            @media only screen and (max-width: $screen-xs-max) {
                grid-template-columns: 32px 1fr 32px;
                grid-gap: 0;
            }

            .content {
                grid-column: 2 / span 2;
                display: grid;
                grid-template-columns: 1fr 2fr;
                grid-gap: 24px;
                grid-template-rows: auto auto;
                grid-template-areas: 'description stats' 'names names' 'quotes quotes';

                @media only screen and (max-width: $screen-sm-max) {
                    grid-template-columns: 1fr 1fr;
                    grid-template-areas: 'description names' 'stats names' 'quotes quotes';
                }

                @media only screen and (max-width: $screen-xs-max) {
                    grid-template-columns: 1fr;
                    grid-column: 2;
                    grid-template-areas: 'description' 'names' 'stats' 'quotes';
                }

                .description {
                    grid-area: description;
                }

                .names {
                    grid-area: names;
                    padding-left: 18px;
                    columns: 3;

                    @media only screen and (max-width: $screen-md-max) {
                        columns: 2;
                    }

                    @media only screen and (max-width: $screen-sm-max) {
                        columns: 1;
                    }

                }

                .stats {
                    grid-area: stats;
                    display: grid;
                    grid-auto-flow: column;
                    grid-gap: 12px;

                    @media only screen and (max-width: $screen-sm-max) {
                        grid-auto-flow: row;
                    }

                }

                .quotes {
                    display: grid;
                    grid-auto-flow: row;
                    grid-gap: 16px;
                    
                    grid-area: quotes;
                    margin-bottom: 24px;

                    .quote {
                        padding-left: 24px;
                        border-left: 2px solid $entelect-dark-blue;

                        .post-title, .post-author {
                            color: $entelect-dark-blue;
                            padding: 12px 0;
                        }

                        .post {
                            text-align: justify;
                        }
                    }
                }
            }
        }
    }
</style>
